/* eslint-disable import/prefer-default-export */
import { API_URL } from '../../../../utils/config';

export const GET_ALL_CALL_STATIONS_URL = `${API_URL}/callstation`;
